var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09512 16.1664H0.759766",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2402 16.1664C19.2402 16.7663 19.069 17.3527 18.7484 17.8515C18.4278 18.3503 17.972 18.7391 17.4388 18.9687C16.9057 19.1982 16.319 19.2584 15.753 19.1413C15.187 19.0243 14.667 18.7354 14.259 18.3112C13.8509 17.887 13.573 17.3465 13.4604 16.7582C13.3478 16.1698 13.4056 15.5598 13.6264 15.0056C13.8473 14.4514 14.2213 13.9777 14.7011 13.6444C15.181 13.3111 15.7451 13.1332 16.3222 13.1332C16.7054 13.1332 17.0848 13.2117 17.4388 13.3641C17.7929 13.5165 18.1146 13.7399 18.3855 14.0216C18.6565 14.3032 18.8714 14.6376 19.018 15.0056C19.1647 15.3736 19.2402 15.7681 19.2402 16.1664V16.1664Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9043 3.82309H19.2396",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.759766 3.8231C0.759766 4.423 0.930883 5.00937 1.25151 5.50817C1.57214 6.00697 2.02789 6.39581 2.56108 6.62538C3.09426 6.85495 3.68091 6.91495 4.24693 6.79791C4.81296 6.68087 5.33288 6.39198 5.74096 5.96778C6.14904 5.54358 6.42696 5.00312 6.53955 4.41474C6.65214 3.82636 6.59437 3.21654 6.37352 2.6623C6.15266 2.10806 5.77867 1.63437 5.29881 1.30108C4.81896 0.967793 4.25482 0.789917 3.6777 0.789917C3.29452 0.789917 2.9151 0.868384 2.56108 1.02082C2.20706 1.17325 1.88534 1.39663 1.61438 1.67829C1.34343 1.95994 1.12853 2.2943 0.981892 2.6623C0.835252 3.03031 0.759766 3.42478 0.759766 3.8231V3.8231Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterWhite);
export default __webpack_public_path__ + "static/media/filter_white.97a7d5c0102a9d8ef604664f24a8cf58.svg";
export { ForwardRef as ReactComponent };